import "../styles/products.css";
// import { Link } from "react-router-dom";

// import productsBg from "../assets/images/productsbg.jpg";

import signia from "../assets/images/signia.png";
import phonak from "../assets/images/phonak.png";
import widex from "../assets/images/widex.png";
import resound from "../assets/images/resound.png";
import hansaton from "../assets/images/hansaton.png";

function Products() {

  const brands = [
    {
      image: signia,
      name: "Signia",
      desc: "AI-powered hearing aids with exceptional speech clarity and Bluetooth connectivity."
    },
    {
      image: phonak,
      name: "Phonak",
      desc: "World-leading hearing technology with natural sound quality and rechargeable options."
    },
    {
      image: widex,
      name: "Widex",
      desc: "Premium hearing aids delivering crystal-clear sound with personalized listening."
    },
    {
      image: resound,
      name: "ReSound",
      desc: "Smart hearing solutions designed for comfort and seamless connectivity."
    },

    {
      image: hansaton,
      name: "Hansaton",
      desc: "German-engineered hearing aids with modern digital technology."
    }
  ];

  return (
    <>

      {/* Hero */}

      <section
        className="products-hero" data-aos="fade-up"
      >

        <div className="products-overlay">

          <div className="hero-content">

            <h1>Digital Hearing Aids</h1>

            <p>
              Discover the world's leading hearing aid brands with advanced
              technology, superior comfort, and personalized hearing solutions.
            </p>

          </div>

        </div>

      </section>

      {/* Intro */}

      <section className="products-intro">

        <h2>Premium Hearing Aid Brands</h2>

        <p>
          We provide hearing aids from internationally trusted manufacturers,
          ensuring every patient receives the best technology for their hearing
          needs.
        </p>

      </section>

      {/* Brand Cards */}

      <section className="products-grid" data-aos="zoom-in" data-aos-duration="4000">

        {brands.map((brand, index) => (

          <div className="product-card" key={index} data-aos="fade-up" data-aos-duration="1200" data-aos-delay={index * 150}>

            <img
              src={brand.image}
              alt={brand.name}
            />


            <p>{brand.desc}</p>

            {/* <button>
              Learn More
            </button> */}

          </div>

        ))}

      </section>

      {/* ================= Why Choose ================= */}

      <section className="products-features">

        <div className="features-heading">

          <h2>Why Choose Our Hearing Aids?</h2>

          <p>
            We offer only genuine hearing aids from globally recognized brands,
            ensuring exceptional sound quality, comfort, and long-term
            reliability.
          </p>

        </div>

        <div className="features-grid">

          <div className="feature-card" data-aos="zoom-in" data-aos-duration="900" data-aos-delay="0">

            <h3>Latest Technology</h3>

            <p>
              AI-powered hearing aids with Bluetooth connectivity, noise
              reduction, and speech enhancement.
            </p>

          </div>

          <div className="feature-card" data-aos="zoom-in" data-aos-duration="900" data-aos-delay="200">

            <h3>Personalized Fitting</h3>

            <p>
              Every hearing aid is professionally programmed according to your
              unique hearing profile.
            </p>

          </div>

          <div className="feature-card" data-aos="zoom-in" data-aos-duration="900" data-aos-delay="400">

            <h3>Comfort & Style</h3>

            <p>
              Invisible, rechargeable, and lightweight hearing aids designed
              for everyday comfort.
            </p>

          </div>

          <div className="feature-card" data-aos="zoom-in" data-aos-duration="900" data-aos-delay="600">

            <h3>After Sales Support</h3>

            <p>
              Lifetime servicing, programming, maintenance, and expert
              consultation whenever you need assistance.
            </p>

          </div>

        </div>

      </section>

      {/* ================= CTA ================= */}

      {/* <section className="products-cta">

        <h2>Find the Perfect Hearing Aid</h2>

        <p>
          Visit Jagadish Hearing Aids and let our experienced audiologists help
          you choose the right hearing solution.
        </p>

        <Link to="/contact">
          <button className="products-btn">
            Book Hearing Test
          </button>
        </Link>

      </section> */}

    </>
  );
}

export default Products;